export { default as Carousel } from './wrapper'
export { default as CarouselControls } from './controls'
export { default as CarouselNavigation } from './navigation'
export { default as CarouselPagination } from './pagination'
export { SwiperSlide as CarouselSlide } from 'swiper/react'
